import { LayaGL } from "../layagl/LayaGL";
import { StatElement } from "../layagl/StatisticsContext";
import { GraphicsRunner } from "./Scene2DSpecial/GraphicsRunner";
export class Render2DProcessor {
    static __init__() {
        Render2DProcessor.runner = new GraphicsRunner();
        Render2DProcessor.rendercontext2D = LayaGL.render2DRenderPassFactory.createRenderContext2D();
    }
    get basePass() {
        return this._basePass;
    }
    constructor() {
        this._basePass = LayaGL.render2DRenderPassFactory.createRender2DPass();
        this._manager = LayaGL.render2DRenderPassFactory.createRender2DPassManager();
        this._basePass.doClearColor = false;
        this._basePass.priority = 0;
        this.addPass(this._basePass);
    }
    addPass(pass) {
        this._manager.addPass(pass);
    }
    removePass(pass) {
        this._manager.removePass(pass);
    }
    apply(context2D, renderTime = Render2DProcessor.renderTime) {
        let t = performance.now();
        this._manager.apply(context2D, renderTime);
        LayaGL.statAgent.recordTimeData(StatElement.T_2DPass, performance.now() - t);
    }
    clear() {
        this._manager.clear();
    }
}
Render2DProcessor.renderTime = 0;
